// isAudience_Activate.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ActiveState {
    is_active: boolean;
}

const initialState: ActiveState = {
    is_active: false, // Initial value
};

const isAudience_Activate = createSlice({
    name: 'active',
    initialState,
    reducers: {
        setIsActive: (state, action: PayloadAction<boolean>) => {
            state.is_active = action.payload;
        },
        toggleIsActive: (state) => {
            state.is_active = !state.is_active; // Toggle boolean state
        },
    },
});

// Export the actions so you can dispatch them in components
export const { setIsActive, toggleIsActive } = isAudience_Activate.actions;

// Export the reducer to use in the store
export default isAudience_Activate.reducer;
